// src/store/actions/authActions.js
import * as actionTypes from './actionTypes';

// Action creators
export const authStart = () => ({
  type: actionTypes.AUTH_START,
});

export const registerStart = () => ({
  type: actionTypes.REGISTER_START,
});

export const authSuccess = (userData) => ({
  type: actionTypes.AUTH_SUCCESS,
  payload: userData,
});

export const registerSuccess = (userData) => ({
  type: actionTypes.REGISTER_SUCCESS,
  payload: userData,
});

export const authFail = (error) => ({
  type: actionTypes.AUTH_FAIL,
  payload: error,
});

export const registerFail = (error) => ({
  type: actionTypes.REGISTER_FAIL,
  payload: error,
});


export const clearAuthError = () => ({
  type: actionTypes.CLEAR_AUTH_ERROR,
});

export const clearRegisterError = () => ({
  type: actionTypes.CLEAR_REGISTER_ERROR,
});



// Async action to handle login
export const login = (credentials) => {
  return async (dispatch, getState, { authService }) => {
    dispatch(authStart());
    try {
      const response = await authService.login(credentials);
      console.log(response);
      
      const { user, accessToken, refreshToken } = response.data;
      
      // Store token in localStorage
      localStorage.setItem('token', accessToken);
      
      dispatch(authSuccess({ user, accessToken, refreshToken }));
    } catch (error) {
      dispatch(authFail(error.response?.data?.message || 'Login failed'));
    }
  };
};

// Async action to handle registration
export const register = (userData) => {
  return async (dispatch, getState, { authService }) => {
    dispatch(registerStart());
    try {
      const response = await authService.register(userData);
      const { user } = response.data;
      
      dispatch(registerSuccess({ user }));
    } catch (error) {
      dispatch(registerFail(error.response?.data?.message || 'Registration failed'));
    }
  };
};

// Check if user is already authenticated (on app load)
export const checkAuthState = () => {
  return async (dispatch, getState, { authService }) => {
    const token = localStorage.getItem('token');
    if (!token) {
      dispatch(logout());
    } else {
      try {
        // Verify token is still valid
        const response = await authService.verifyToken(token);
        const user = response.data.user;
        console.log(user);
        
        dispatch(authSuccess({ user, token }));
      } catch (error) {
        dispatch(logout());
      }
    }
  };
};

// Logout action
export const logout = () => {
  // Clear tokens from storage
  if (process.env.NODE_ENV === 'production') {
    sessionStorage.removeItem('access_token');
  } else {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
  }
  
  return {
    type: actionTypes.AUTH_ACTIONS.LOGOUT,
  };
};

// Refresh token action
export const refreshToken = (token) => ({
  type: actionTypes.AUTH_ACTIONS.REFRESH_TOKEN,
  payload: token,
});

// Set tokens action
export const setTokens = (token, refreshToken) => ({
  type: actionTypes.AUTH_ACTIONS.SET_TOKENS,
  payload: { token, refreshToken },
});